import React from 'react';
import { Text } from '@moda/om';
import { FineJewelryReturnMessage } from '../FineJewelryReturnMessage';

interface Props {
  isFineJewelry: boolean;
  isFineJewelryReturnPolicyCovered: boolean;
  isReturnable: boolean;
  message: string;
  showNewMessageForFineJewelryReturns: boolean;
  status: string;
}

export const OrderItemDetailsReturnPolicyMessage: React.FC<Props> = ({
  isFineJewelry,
  isFineJewelryReturnPolicyCovered,
  isReturnable,
  message,
  showNewMessageForFineJewelryReturns,
  status
}) => {
  if (isReturnable) {
    if (isFineJewelry && showNewMessageForFineJewelryReturns) {
      if (status === 'shipped' && isFineJewelryReturnPolicyCovered) {
        return (
          <FineJewelryReturnMessage
            showNewMessageForFineJewelryReturns={showNewMessageForFineJewelryReturns}
          />
        );
      } else return null;
    } else return <Text>{message}</Text>;
  }

  return null;
};
